import { getSaviorStatRank, getSaviorStatRanks } from "./getSaviorStatRanks";
import CONFIG from "../config/modal_savior_status_config.json";

let maxStat = null;

const construct = () => {
    if (!maxStat) {
        const ranks = getSaviorStatRanks();
        maxStat = {};

        CONFIG.STATUS.forEach((config) => {
            const sorted = [...ranks].sort((a, b) => b.status[config.value] - a.status[config.value]);

            maxStat[config.value] = sorted[0].status[config.value];
        });
    }
};

const getSaviorStatProgress = (savior, statName) => {
    if (!maxStat) construct();

    const found = getSaviorStatRank(savior);
    return Math.min(100, (found.status[statName] / maxStat[statName]) * 100);
};

export default getSaviorStatProgress;
